import React from 'react'
import { useNavigate } from 'react-router'
import styled from 'styled-components'

import { useTypedNavigation } from '@/shared/hooks/useTypedNavigate'
import HeaderCampaignIcon from '../icons/HeaderCampaignIcon'
import BaseHeader from './BaseHeader'
import { BackButton, HeaderLogo, HeaderTitle } from './header'

interface AppHeaderProps {
  variant?: 'default' | 'back' | 'campaign' | 'none' | 'text'
  title?: string
  onBack?: () => void
  backTo?: string
  actions?: React.ReactNode
  sticky?: boolean
  border?: boolean
}

const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex: 1;
`

function AppHeader({
  variant = 'default',
  title,
  onBack,
  backTo,
  sticky = false,
  border = true,
}: AppHeaderProps) {
  const navigate = useNavigate()
  const nav = useTypedNavigation()

  // none variant는 헤더를 렌더링하지 않음
  if (variant === 'none') {
    return null
  }

  // 뒤로가기 핸들러 결정
  const handleBack = () => {
    if (onBack) {
      onBack()
    } else if (backTo) {
      navigate(backTo)
    } else {
      navigate(-1)
    }
  }

  // 왼쪽 슬롯 콘텐츠 결정
  const getLeftContent = () => {
    switch (variant) {
      case 'text':
        return <HeaderTitle title={title} />
      case 'back':
        return (
          <HeaderTitleContainer>
            <BackButton onClick={handleBack} />
            <HeaderTitle title={title} />
          </HeaderTitleContainer>
        )
      case 'campaign':
        return <HeaderCampaignIcon onClick={() => nav.home()} />
      case 'default':
      default:
        return <HeaderLogo />
    }
  }

  // 오른쪽 슬롯 콘텐츠 결정
  const getRightContent = () => {
    return null
  }

  return (
    <BaseHeader left={getLeftContent()} right={getRightContent()} sticky={sticky} border={border} />
  )
}

export default AppHeader
